const initProductsContainer = () => {
  const productContainer = document.querySelector('[data-role="product-container"]') as HTMLElement;
  const controls = document.querySelectorAll('[data-role="view-option-display"]');

  if (null === productContainer || null === controls) {
    return;
  }

  const cookieName = 'view_option_display_type';
  const gridClass = 'product-cards';
  const listClass = 'product-list';

  const changeDisplay = function (display) {
    if (display === 'grid') {
      productContainer.classList.replace(listClass, gridClass);
    } else {
      productContainer.classList.replace(gridClass, listClass);
    }
  };

  [].forEach.call(controls, function (controlElem) {
    controlElem.addEventListener('click', (e) => {
      e.preventDefault();

      const display = controlElem.getAttribute('data-d');
      changeDisplay(display);

      controlElem.classList.add('active');

      const secondMode = Array.from(controls).filter((e) => {
        return e.getAttribute('data-d') !== display;
      });

      if (secondMode) secondMode[0].classList.remove('active');

      const date = new Date();
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * 30);
      document.cookie = cookieName + '=' + controlElem.getAttribute('data-i') + ';expires=' + date.toUTCString();
    });
  });
};

export default initProductsContainer;

